import { render, staticRenderFns } from "./CurrencyTagList.vue?vue&type=template&id=3a89c865&"
import script from "./CurrencyTagList.vue?vue&type=script&lang=js&"
export * from "./CurrencyTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports